import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  inject,
} from '@angular/core';
import { FilePondOptions } from 'filepond';
import { FilePondComponent } from 'ngx-filepond';
import { FilePondConfigService } from '../../services/filepond-config.service';
import { Store } from '@ngrx/store';
import { State } from '../../core/state';
@Component({
  selector: 'black-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.css',
  standalone: false,
})
export class UserAvatarComponent implements OnInit, OnChanges {
  private store = inject<Store<State>>(Store);
  private filePondConfig = inject(FilePondConfigService);

  @ViewChild('myPond')
  myPond!: FilePondComponent;

  pondFiles: FilePondOptions['files'] = [];

  @Output()
  uploadSuccess = new EventEmitter<string>();

  @Input()
  allowEdit = false;

  pondOptions: FilePondOptions = {
    labelIdle: `Drag & Drop your picture or <span class="filepond--label-action">Browse</span>`,
    imagePreviewHeight: 170,
    imageCropAspectRatio: '1:1',
    imageResizeTargetWidth: 200,
    imageResizeTargetHeight: 200,
    stylePanelLayout: 'compact circle',
    styleLoadIndicatorPosition: 'center bottom',
    styleProgressIndicatorPosition: 'right bottom',
    styleButtonRemoveItemPosition: 'left bottom',
    styleButtonProcessItemPosition: 'right bottom',
    allowFileTypeValidation: true,
    acceptedFileTypes: ['image/png', 'image/jpeg'],
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (this.allowEdit) {
      this.pondOptions = { ...this.pondOptions, disabled: false };
    } else {
      this.pondOptions = { ...this.pondOptions, disabled: true };
    }
  }

  async ngOnInit(): Promise<void> {
    const server = await this.filePondConfig.getServerConfig({
      load: true,
      allowRevert: true,
    });
    this.pondOptions = {
      ...this.pondOptions,
      server,
    };

    this.store
      .select((state) => state.users.user)
      .subscribe((userState) => {
        const avatar = userState?.profile?.personal.avatar;

        if (avatar && this.pondFiles) {
          this.pondFiles.push({
            source: avatar._id,
            options: {
              type: 'local',
            },
          });
        }
      });
  }

  pondHandleProcessFile(event: any) {
    const resourceId = event.file.serverId;
    this.uploadSuccess.emit(resourceId);
  }

  pondHandleRevertFile(event: any) {
    console.log('file reverted');
  }
}
